import { createContext, use } from 'react';

import type { ColorTheme } from '~/api/user/types';

import { noop } from '~/utils/functions';

export const ColorThemeContext = createContext<{
  colorTheme: ColorTheme;
  setColorTheme: (colorTheme: (ColorTheme | null) | ((old: ColorTheme | null) => ColorTheme | null)) => void;
}>({
  colorTheme: 'green-pink',
  setColorTheme: noop,
});

export const useColorThemeContext = () => use(ColorThemeContext);
